import { render, staticRenderFns } from "./TransferPlanPage.vue?vue&type=template&id=543e93ee"
import script from "./TransferPlanPage.vue?vue&type=script&lang=js"
export * from "./TransferPlanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports